/**
 * @fileoverview React binding for the theme store in `lib/theme.js`.
 *
 * `useSyncExternalStore` rather than a context: the theme is document-wide
 * state that lives outside React (the boot script sets it before React
 * exists), and every portal — instructor, student, org, ops — needs the same
 * answer without each shell wrapping itself in a provider.
 */

import { useCallback, useSyncExternalStore } from "react";
import { DEFAULT_THEME, getTheme, setTheme, subscribe } from "@/lib/theme";

const getServerSnapshot = () => DEFAULT_THEME;

/**
 * @returns {[string, (theme: string) => void]} The current theme and a setter.
 */
export default function useTheme() {
  const theme = useSyncExternalStore(subscribe, getTheme, getServerSnapshot);
  const set = useCallback((next) => setTheme(next), []);
  return [theme, set];
}
